import { post } from "./api.service";

const TagService = {
  searchTags(params) {
    return post("/tags/search", params);
  },
};

export { TagService };
